import * as React from 'react';
import styled from 'styled-components';

import { getColor, getShadow } from '@process-advisor/process-miner/shared/theme';
import { colors } from '@process-advisor/process-miner/components/colorPicker/colors';

const Color = styled.div<{ color?: string }>`
    width: 16px;
    height: 16px;
    border-radius: 3px;
    background-color: ${({ color }) => color};
    cursor: pointer;
    transition: box-shadow .2s;
    display: flex;
    justify-content: center;
    align-items: center;

    &:last-child {
        border: 1px solid ${getColor('borderColor')};
    }

    &:hover {
        box-shadow: ${getShadow('hover')};
    }
`;

const Grid = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-top: 14px;

    ${Color} {
        margin-bottom: 9px;
        margin-right: 9px;
    }
`;

type Props = {
    onColorChange: (color: string) => void;
};

export const ColorsGrid: React.FC<Props> = ({ onColorChange }) => {
    const onClick = (color) => () => {
        onColorChange(color);
    };

    return (
        <Grid>
            {
                colors.map((color: string) => (
                    <Color
                        onClick={onClick(color)}
                        key={color}
                        color={color} />
                ))
            }
        </Grid>
    );
};
